module.exports = __webpack_public_path__ + "img/operator6.5fc63556.png";